import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import * as React from "react";
import { ReactNode } from "react";


interface SidebarMenuItemProps {
    text: string;
    index: number;
    openedIndex: number;
    open: boolean;
    icon?: ReactNode;
    onClick: () => void;
}

const SidebarMenuItem = (props: SidebarMenuItemProps) => {
  return (
      <>
          <ListItem
              key={props.text}
              disablePadding
              sx={{ display: 'block' }}
          >
              <ListItemButton
                  selected={props.openedIndex === props.index}
                  onClick={props.onClick}
                  sx={[
                      {
                          minHeight: 48,
                          px: 2.5,
                      },
                      props.open
                          ? {
                              justifyContent: 'initial',
                          }
                          : {
                              justifyContent: 'center',
                          },
                  ]}
              >
                  <ListItemIcon
                      sx={[
                          {
                              minWidth: 0,
                              justifyContent: 'center',
                          },
                          props.open
                              ? {
                                  mr: 3,
                              }
                              : {
                                  mr: 'auto',
                              },
                      ]}
                  >
                      {props.icon}
                  </ListItemIcon>
                  <ListItemText
                      primary={props.text}
                      sx={[
                          props.open
                              ? {
                                  opacity: 1,
                              }
                              : {
                                  opacity: 0,
                              },
                      ]}
                  />
              </ListItemButton>
          </ListItem>
      </>
  );
}

export default SidebarMenuItem;
